module.exports = __webpack_public_path__ + "img/5.9972927b.jpg";